import React from 'react'
import './Footer.css'
import { FaWeight } from 'react-icons/fa'
import { Link} from "react-router-dom";
import { FaFacebookSquare } from "react-icons/fa";

const Footer = () => (
    <div>
        <footer class="footer-section" style={{padding:"2px"}}>
            <div class="container" >
                <div class="footer-cta pt-5 pb-5 responsive_footer_first" >
                    <div class="row" >
                        <div class="col-xl-4 col-md-4 mb-30" >
                            <div class="single-cta responsive_single_cta" >
                                <i class="fas fa-map-marker-alt fa-2x" style={{marginRight:"20px"}}></i>
                                <h4 style={{ color: "white",fontFamily:"Nunito" }}>Address</h4>
                                {/* <span style={{color:"white",fontSize:"18px",fontWeight:"700",}}>No.91/2, Garudacharpalya,Behind Brigade, Metroplis,Mahadevapura post,<br/> Bengaluru-560048</span> */}
                                <div style={{ color: "white", fontSize: "16px", fontWeight: "700", display: "flex",fontFamily:"Nunito", flexDirection: "column" }}>
                                    <span>No.91/2, Garudacharpalya, Mahadevapura Post, Behind Brigade Metropolis, Bengaluru-560048</span>
                                    <span style={{ textAlign: "left",fontFamily:"Nunito" }}></span>
                                </div>

                            </div>
                        </div>
                        <div class="col-xl-4 col-md-4 mb-30">
                            <div class="single-cta responsive_phone">
                                <i class="fas fa-phone" style={{marginRight:"20px"}}></i>
                                <div class="cta-text">
                                    <h4 style={{ color: "white",fontFamily:"Nunito"}}>Call us</h4>
                                    <span style={{ color: "white", fontSize: "16px", fontWeight: "700",fontFamily:"Nunito" }}>+91 ⁠9845164986/+91 9980411999<br/> +91 7892882698</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-4 mb-30">
                            <div class="single-cta">
                                <i class="far fa-envelope-open" style={{marginRight:"20px"}}></i>
                                <div class="cta-text">
                                    <h4 style={{fontFamily:"Nunito"}}>Mail us</h4>
                                    <span style={{ color: "white", fontSize: "16px", fontWeight: "700",fontFamily:"Nunito" }}><a href='mailto:gifcoautofilters@gmail.com' style={{color:"white",textDecoration:'none'}}>Email: gifcoautofilters@gmail.com</a></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-content pt-5 pb-5">
                    <div class="row">
                        <div class="col-xl-4 col-lg-4 mb-50">
                            <div class="footer-widget">
                                <div class="footer-logo">
                                    <a href="index.html"><img src="./images/logo2.png" class="img-fluid" alt="logo" /></a>
                                </div>
                                <div class="footer-text" style={{textAlign:"justify"}}>
            <p>“Leading the way in filtration, Gafi filters top tier solution for automotives, setting the standard for execellence”</p>
        </div>
                                <div class="footer-social-icon" >
                                    <span>Follow us</span>
                                    <a href="#"><i class="fab fa-facebook-square fa-xs" style={{color: "white",fontSize:"40px"}}></i></a>
                                    <a href="#" style={{marginRight: "90px"}}><i class="fab fa-instagram" style={{color:"white",fontSize:"40px"}}></i></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-6 mb-30">
                            <div class="footer-widget">
                                <div class="footer-widget-heading">
                                    <h3 style={{fontFamily:"Nunito"}}>Useful Links</h3>
                                    
                                </div>
                                <ul>
                                    <li><Link to="/" style={{ textDecoration: "none",fontFamily:"Nunito" }}>Home</Link></li>
                                    <li><Link to="/about" style={{ textDecoration: "none",fontFamily:"Nunito" }}>about</Link></li>
                                    <li><Link to="/services" style={{ textDecoration: "none",fontFamily:"Nunito" }}>Products</Link></li>
                                     <li><Link to="/Testimonial" style={{ textDecoration: "none",fontFamily:"Nunito" }}>Gallery</Link></li>
                                    <li><Link to="/contact" style={{ textDecoration: "none",fontFamily:"Nunito" }}>Contact us</Link></li>

                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 mb-50">
                            <div class="footer-widget">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15550.989442804444!2d77.7029446!3d12.9880041!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae119c37eda619%3A0xf0d42d973cb0f3c6!2sGifco%20Auto%20Filters%20India!5e0!3m2!1sen!2sin!4v1712809794219!5m2!1sen!2sin" width="100%" height="330" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div className='bottom_header'>
                    <p> ©2024GAFI. All Rights Reserved.</p>
                    <a href='https://www.excerptech.com/' target='_black' style={{color:"white",textDecoration:"none",fontFamily:"Nunito"}}>Designed By Excerpt Technologies Pvt.Ltd</a>
                </div>
            </div>
            
            
        </footer>
    </div>
)

export default Footer
